import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/users'

export default {

  async get (id) {
    const headers = await getHeaders()
    return axios.get('/users/' + id, { headers })
  },

  async update (id, user) {
    const headers = await getHeaders()
    return axios.put('/users/' + id, user, { headers })
  },

  async search (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/search', criterias, { headers })
  },

  async initCreateUser (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/initCreateUser', criterias, { headers })
  },

  async create (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/create', criterias, { headers })
  },

  async initUserUpdate (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/initUserUpdate', criterias, { headers })
  },

  async edit (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/update', criterias, { headers })
  },

  async delete (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/delete', criterias, { headers })
  },

  async lockUser (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/lock', criterias, { headers })
  },

  async unlockUser (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/unlock', criterias, { headers })
  },

  async resetOtp (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/resetOtp', criterias, { headers })
  },

  async reinitPwd (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/resetPassword', criterias, { headers })
  },

}
